const aaa = [
	{
		path: "export",
		component: () => import("@/views/caiwu/export/list.vue"),
		meta:{title:'报表导出'},
	},
]
export default aaa;